import * as React from "react";
import { useRouter } from "next/router";
import { useMachine } from "@xstate/react";
import { useMemberOrchestrator } from "@nju/data-access-portal-member";
import {
  checkPaymentMachine,
  PaymentNotification,
} from "@nju/feature-portal-payment";
import { portalRoutes } from "@nju/routes";
import { BlikErrorMessage } from "./partials/BlikErrorMessage";

export function BlikConfirmPage() {
  const memberOrchestrators = useMemberOrchestrator();
  const router = useRouter();
  const [{ matches }] = useMachine(checkPaymentMachine, {
    context: {
      paymentId: (router.query.id || "").toString(),
    },
    actions: {
      onSuccessRedirect: () => {
        router.push(
          portalRoutes.mojeKonto.index.get({
            mode: "mobile",
            ...(memberOrchestrators.mobile?.userId && {
              userId: memberOrchestrators.mobile?.userId,
            }),
          }),
        );
      },
    },
  });

  if (matches("error")) {
    return <BlikErrorMessage />;
  }

  return (
    <PaymentNotification
      iconName="mobile-alt-incircle-succes"
      linkVariant="secondary"
      redirectUrl={portalRoutes.mojeKonto.index.get({
        mode: "mobile",
        ...(memberOrchestrators.mobile?.userId && {
          userId: memberOrchestrators.mobile?.userId,
        }),
      })}
      textButton="powrót"
      title="potwierdź płatność w swojej aplikacji bankowej"
      userId={memberOrchestrators.mobile?.userId}
    />
  );
}
